import AccreditationsModalView from "./accreditationsModal.html";


angular.module("events")
.controller("EventsAccreditationsCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'uiGridConstants', '$timeout', '$q', '$http', 'uiGridTreeViewConstants', 'treeService', '$sce', 'logService',
    function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, uiGridConstants, $timeout, $q, $http, uiGridTreeViewConstants, treeService, $sce, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_ACCREDITATION_WRITE");
        if(!Array.isArray($scope.$parent.menusItems)) {
            $state.go("events.edit", { id: $stateParams.id });
        } else {
            let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
            if(results.length > 0) {
                $scope.allowWrite &&= results[0].editable;
            } else {
                $scope.allowWrite = false;
            }
        }
        $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: event.name, url: "events.edit({ id: " + event.id + " })" },
                { title: $filter('translate')('events.accreditations.accreditations') }
        ];
        $rootScope.title = event.name + " - " + $filter('translate')('events.accreditations.accreditations');


    $scope.accreditations = {};

    function isDefinedAndNotNull(val) {
        return angular.isDefined(val) && val !== null
    }

    $scope.is_template = $stateParams.is_template == 'true';
    $scope.gridOptionsEventAccreditations = {
        pdfTitle: function () { return event.name + " - " + $filter('translate')('events.accreditations.pdf_title'); },
        exporterMenuCsv: true,
        enableGridMenu: true,
        showTreeExpandNoChildren: false,
        enableSorting: true,
        rowTemplate: '<div ng-dblclick="grid.appScope.addEventAccreditation(row.entity.id)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
        paginationPageSizes: [10, 20, 40],
        paginationPageSize: 10,
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
        },
        columnDefs: [
            { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
            {
                name: 'color', displayName: $filter('translate')('events.accreditations.color'), width: 60, enableFiltering: false, enableHiding: false, enableColumnMenu: false,
                cellTemplate: '<div class="ui-grid-cell-contents"><div style="background-color: {{row.entity.color}}">&nbsp;</div></div>',
            },
            {
                name: 'name', displayName: $filter('translate')('events.accreditations.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,
                cellTemplate: '<div class="ui-grid-cell-contents"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.name" popover-append-to-body="true">{{row.entity.name}}</a></div>',
            },
            {
                name: ' ', width: 60, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                    { title: "", action: ' ng-click="grid.appScope.addEventAccreditation(row.entity.id)" ng-if="grid.appScope.allowWrite && row.entity.id != null"', cssIconClass: "fa fa-edit" },
                    { title: "", action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite && row.entity.id != null"', cssIconClass: "fa fa-remove" }
                ], { cssClass: "pull-right" })
            },
        ],
        getData: function (options) {
            var deferred = $q.defer();

            options.event_id = $stateParams.id;
            Restangular.all('EventsGuestsAccreditations').getList(options).then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;

        }
    };



    $scope.addEventAccreditation = function (id) {

        logService.debug(id);

        let $modalInstance = $uibModal.open({
            animation: true,
            template: AccreditationsModalView,
            controller: "AccreditationsModalCtrl",
            size: 'md',
            resolve: {
                event_guest_accreditation_id: function () {
                    return id;
                },
                event_id: function () {
                    return $stateParams.id;
                }
            }

        });

        //Retorno de los datos desde el modal.
        $modalInstance.result.then(function (resultModal) {
            $scope.gridOptionsEventAccreditations.loadData(false);
        }, function () {
            console.info('Modal dismissed at: ' + new Date());
        });

    };

    //Delete desde el listado
    $scope.deleteDialog = function (id, title) {

        modalService.confirm({
            title: $filter('translate')('events.accreditations.button_delete'),
            message: $filter('translate')('events.accreditations.delete_message') + " " + title + "?",
            onAccept: function () {
                Restangular.one('EventsGuestsAccreditations', id).remove().then(function () {
                    toastr.success($filter('translate')('events.accreditations.deleted_success'));
                    $scope.gridOptionsEventAccreditations.loadData();
                }, function (response) {
                    logService.error("Error with status code", response.status);
                    alert("Error al borrar")
                });
            }
        });

    };

}])

.controller("AccreditationsModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'event_guest_accreditation_id', 'event_id', 'logService',
    function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event_guest_accreditation_id, event_id, logService) {

    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("EVENTS_ACCREDITATION_WRITE");

    $scope.is_template = $stateParams.is_template == 'true';
    $scope.eventAccreditation = {};

    logService.debug(event_guest_accreditation_id);

    if (angular.isUndefined(event_guest_accreditation_id) || event_guest_accreditation_id == null || typeof(event_guest_accreditation_id) === 'undefined') {
        $scope.eventAccreditation.event_id = event_id;
        $scope.eventAccreditation.id = 0;


    }
    else {

        Restangular.one('EventsGuestsAccreditations', event_guest_accreditation_id).get().then(function (results) {
            $scope.eventAccreditation = results;

        });
    }

    $scope.saveEventAccreditation = function () {
        if ($scope.eventAccreditation.id == 0) $scope.eventAccreditation.id = null;

        if (angular.isDefined($scope.eventAccreditation.id) && $scope.eventAccreditation.id!=null) {
            $scope.eventAccreditation.put().then(function (result) {
                if (angular.isDefined(result.id)) {
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('events.accreditations.edit_success'));
                }
            });
        } else {
            Restangular.all('EventsGuestsAccreditations').post($scope.eventAccreditation).then(function (result) {
                if (angular.isDefined(result.id)) {
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('events.accreditations.add_success'));

                }
            });
        }
    }

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    //Delete desde el popup
    $scope.checkDeleteEventAccreditation = function () {
        modalService.confirm({
            title: $filter('translate')('events.accreditations.button_delete'),
            message: $filter('translate')('events.accreditations.delete_message') + " " + $scope.eventAccreditation.name + "?",
            onAccept: function () {
                Restangular.one('EventsGuestsAccreditations', $scope.eventAccreditation.id).remove().then(function () {
                    $uibModalInstance.close();
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                });
            }
        });
    };

}])

;

;
